import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { flatColorsByRelationId, flatFontsByRelationId } from 'containers/Common/selectors';
import { CallToActionBrandProps } from '../brandProps';

export function useCallToActionBrandProps(relationId: string): CallToActionBrandProps {
  const flatColors = useSelector(flatColorsByRelationId);
  const flatFonts = useSelector(flatFontsByRelationId);

  return useMemo(
    (): CallToActionBrandProps => ({
      colors: flatColors.get(relationId),
      fonts: flatFonts.get(relationId),
    }),
    [relationId, flatColors, flatFonts],
  );
}
